(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const CLOSE_DELAY = 180;

  const setExpanded = (details, expanded) => {
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;

    if (expanded) {
      document
        .querySelectorAll('.header__inline-menu header-menu > details[open]')
        .forEach((openDetails) => {
          if (openDetails !== details) {
            openDetails.removeAttribute('open');
            openDetails.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
          }
        });
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }
  };

  const initializeMenu = (menu) => {
    if (menu.dataset.pvHoverReady === 'true') return;
    const details = menu.querySelector(':scope > details');
    if (!details) return;

    let closeTimer;
    const cancelClose = () => window.clearTimeout(closeTimer);
    const openMenu = () => {
      if (!desktopHover.matches) return;
      cancelClose();
      setExpanded(details, true);
    };
    const scheduleClose = () => {
      if (!desktopHover.matches) return;
      cancelClose();
      closeTimer = window.setTimeout(() => setExpanded(details, false), CLOSE_DELAY);
    };

    menu.addEventListener('mouseenter', openMenu);
    menu.addEventListener('mouseleave', scheduleClose);
    menu.addEventListener('focusin', openMenu);
    menu.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!menu.contains(document.activeElement)) scheduleClose();
      });
    });

    menu.dataset.pvHoverReady = 'true';
  };

  const initializeAll = () => {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(initializeMenu);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.header__inline-menu header-menu > details[open]').forEach((details) => {
      setExpanded(details, false);
    });
  });
})();
